import { render } from "./B2bNewUserCif.vue?vue&type=template&id=68b14460&scoped=true&lang=pug"
import script from "./B2bNewUserCif.vue?vue&type=script&lang=js"
export * from "./B2bNewUserCif.vue?vue&type=script&lang=js"

import "./B2bNewUserCif.vue?vue&type=style&index=0&id=68b14460&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b14460"]])

export default __exports__